import { useMappedState } from "redux-react-hook";

import type { IStore } from "src/core/shared/store";

// shortcut to get timezone
const useTimezone = () => {
  const { timezone } = useMappedState(({ global }: IStore) => ({ timezone: global.settings && global.settings.timezone ? global.settings.timezone.zone : "Europe/London" }));

  return timezone;
};

export default useTimezone;
